export default "__VITE_ASSET__C019jxkM__"